import type { FC } from "react";
import { NewContractForm } from "web_myplann/Goals/Components/PinContract/NewContractForm";
import { NewContractSuccess } from "web_myplann/Goals/Components/PinContract/NewContractSuccess";
import type { NewContractFormOutput } from "web_myplann/Goals/Forms/newContractFormSchema";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { MyPlannDrawer } from "web_myplann/Shared/Components/MyPlannDrawer";

const PageResources = Resources.Goals.Detail.Solution.Pin.New;

type Props = {
	open: boolean;
	created: boolean;
	isPending: boolean;
	onClose: () => void;
	onSubmit: (values: NewContractFormOutput) => void;
	onMessageAdvisor: () => void;
	onFillDetails: () => void;
};

export const NewContractDrawer: FC<Props> = ({
	open,
	created,
	isPending,
	onClose,
	onSubmit,
	onMessageAdvisor,
	onFillDetails,
}) => {
	const { t } = useResource();

	return (
		<MyPlannDrawer
			anchor="bottom"
			open={open}
			onClose={onClose}
			title={t(
				created ? PageResources.Success.drawerTitle : PageResources.title,
			)}
			closeButton
		>
			{created ? (
				<NewContractSuccess
					onBackToGoal={onClose}
					onFillDetails={onFillDetails}
				/>
			) : (
				<NewContractForm
					open={open}
					isPending={isPending}
					onSubmit={onSubmit}
					onMessageAdvisor={onMessageAdvisor}
				/>
			)}
		</MyPlannDrawer>
	);
};
